import { sortBy, uniq } from 'lodash';
import { SearchOffers } from './apis/elasticsearch/types';

const toMb = (str: string) => {
  const storage = str.toLowerCase();
  const size = Number(storage.replace(/[^0-9.]/g, ''));

  if (storage.includes('gb')) return size * 1024;
  if (storage.includes('tb')) return size * 1024 * 1024;

  return size;
};

export const sortByStorage = (a: string, b: string) => {
  if (a === 'NONE') return 1;
  if (b === 'NONE') return -1;

  return toMb(a) - toMb(b);
};

export const sortByBatteryHealth = (a: string, b: string) =>
  Number(a) - Number(b);

export const sortByScreenSize = (a: string, b: string) => {
  if (a === 'NONE') return 1;
  if (b === 'NONE') return -1;

  const rg = /^\d+\.?\d?/;
  const aInNumber = Number(a.match(rg)?.[0] ?? 0);
  const bInNumber = Number(b.match(rg)?.[0] ?? 0);

  return aInNumber - bInNumber;
};

export const sortByString = (a: string, b: string) => {
  if (a < b) return -1;
  if (a > b) return 1;

  return 0;
};

export const sortOptionByBestSelling = (
  options:
    | {
        key: string;
        count: number;
      }[]
    | undefined,
  bestSelling: SearchOffers[],
  key: string,
) =>
  options &&
  sortBy(options, (item) => {
    const index = uniq(
      bestSelling.map((offer) => offer[key as keyof SearchOffers]),
    ).indexOf(item.key);

    return index === -1 ? Infinity : index;
  });
